import React, { useContext, useEffect } from 'react';
import ReactDOM from 'react-dom';

import { OverlayContext } from '../../ApplicationProviders/OverlayProvider/OverlayContext';
import { TLPageWrapper } from '../../atoms/TLPageWrapper/TLPageWrapper';

import { StyledContainer } from './ContentOverlay.styles';

/**
 * This holds the reference to the div that holds the overlay content
 */
const portalId = 'bnmvcxhjlfayoiuthwuivdsbjioqdnkp';

export const ContentOverlay: React.FC = ({ children }) => {
  const { openOverlay, closeOverlay } = useContext(OverlayContext);

  useEffect(() => {
    openOverlay();

    return () => {
      closeOverlay();
    };
  }, [openOverlay, closeOverlay]);

  const overlayRoot = document.getElementById(portalId);

  if (overlayRoot) {
    return ReactDOM.createPortal(children, overlayRoot);
  }

  return null;
};

/**
 * OverlayPortalSlot is responsible for rendering the overlay content.
 * It receives the content with the help of React Portals, which means the OverlayPortalSlot
 * can be rendered wherever in the DOM-tree.
 *
 * There should only be one OverlayPortalSlot ever.
 */
export const OverlayPortalSlot: React.FC<{ isRedirectMode: boolean }> = ({ isRedirectMode }) => {
  const { hasOverlay } = useContext(OverlayContext);

  return (
    <TLPageWrapper
      id="overlay-portal"
      zIndex={hasOverlay ? 1000 : 0}
      isRedirectMode={isRedirectMode}
    >
      <StyledContainer id={portalId} />
    </TLPageWrapper>
  );
};
